import { createFileRoute } from "@tanstack/react-router"
import DesignSystemProgressBar from "~/pages/design-system/components/ProgressBar"

export const Route = createFileRoute("/_auth/internal/design-system/components/progress-bar")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemProgressBar />
}
